import { Controller } from "@hotwired/stimulus"

// Авто-фильтр списка зарплат: debounce 300мс на текстовом поле,
// мгновенный сабмит при смене типа (Все/Мастера/Сотрудники).
// Форма GET с data-turbo-frame обновляет только таблицу (фокус инпута сохраняется).
// Дополнительно синхронизирует параметры q/type в ссылках навигации месяца.
export default class extends Controller {
  static targets = ["form", "query", "monthLink"]
  static values = { delay: { type: Number, default: 300 } }

  disconnect() {
    clearTimeout(this.timer)
  }

  debouncedSubmit() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    this.syncMonthLinks()
    this.formTarget.requestSubmit()
  }

  // Переносит текущий ФИО-фильтр и тип в href стрелок месяца,
  // чтобы при переходе на другой месяц фильтр не терялся.
  syncMonthLinks() {
    const q = this.hasQueryTarget ? this.queryTarget.value : ""
    const type = this.formTarget.querySelector("input[name='type']:checked")?.value

    this.monthLinkTargets.forEach((link) => {
      const url = new URL(link.href, window.location.origin)
      url.searchParams.set("q", q)
      if (type) url.searchParams.set("type", type)
      link.href = url.toString()
    })
  }
}
